'use strict';
import isString from 'lodash/isString';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import logo from '../../../../img/favicon.png';
import {Button} from '../../../components/buttons/Button';
import {StatefulButton} from '../../../components/buttons/StatefulButton';
import {I18nMessage} from '../../../components/I18nMessage';
import {FormField, INPUT_TYPES, ValidationMode} from '../../../components/forms/FormField';
import {isButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {stopPropagation} from '../../../core-utilities/react-utils';
import {PRIVACY_URL, TOS_URL} from '../../../config/constants';
import {AuthModalMode} from '../../enums/AuthModalMode';

const constraints = {
  nullable: true,
};

const emailConstraints = {
  nullable: false,
};

const passwordConstraints = {
  nullable: false,
  min: 6,
  max: 64,
};

const passwordConfirmConstraints = {
  nullable: false,
  min: 6,
  max: 64,
};

const nameConstraints = {
  nullable: false,
  min: 1,
  max: 24,
};

export const allowedModesPropType = T.oneOf(Object.keys(AuthModalMode));

export function BaseAuthFormView(props) {
  return (
    <div
      className={classNames("AuthForm card", props.className, {
        // 'modal-auto-centered-top': props.keyboardHeight > 0,
        AuthForm_modal: props.isModal,
      })}
      style={props.isModal ? void 0 : props.keyboardStyle}
    >
      <div className="AuthForm__header">
        <div className="AuthForm__avatar">
          <img
            className="AuthForm__avatarIcon"
            src={logo}
          />
        </div>
        {props.currentMode === AuthModalMode.FORGOT_PASSWORD ? (
          <Button
            className="AuthForm__headerBack"
            iconClass="ion-arrow-left-c"
            disabled={props.isFetching}
            onClick={props.onClickShowLogin}
          />
        ) : null}
        {props.showCloseButton ? (
          <Button
            className="AuthForm__headerClose"
            iconClass="ion-android-close"
            disabled={props.isFetching}
            onClick={props.onCancel}
          />
        ) : null}

        Swift Projects
      </div>

      {/* TODO: Sign-Up Temporarily disabled due to internal bug
      {props.allowedModes === AuthModalMode.LOGIN_AND_SIGNUP && props.currentMode !== AuthModalMode.FORGOT_PASSWORD ? (
        <div
          className="AuthForm__modes"
        >
          <Button
            className={classNames("AuthForm__modeButton", {
              AuthForm__modeButton_selected: props.currentMode === AuthModalMode.LOGIN,
            })}
            label={props.loginLabel}
            disabled={props.isFetching}
            onClick={props.onClickShowLogin}
          />
          <Button
            className={classNames("AuthForm__modeButton", {
              AuthForm__modeButton_selected: props.currentMode === AuthModalMode.SIGNUP,
            })}
            label={props.signupLabel}
            disabled={props.isFetching}
            onClick={props.onClickShowSignup}
          />
        </div>
      ) : null}*/}

      <form
        className="AuthForm__scrollPanel"
        onClick={stopPropagation}
        onSubmit={props.onClickOkay}
      >
        <input
          type="submit"
          className="forms-hidden-submit"
          onClick={props.onClickOkay}
        />
        <div className="AuthForm__scroll">

          {isString(props.errorCode) ? (
            <span className="AuthForm__errorMessage">
              <I18nMessage message={props.errorCode} />
            </span>
          ) : null}

          {props.currentMode === AuthModalMode.FORGOT_PASSWORD ? (
            <span className="AuthForm__resetPasswordMessage">
              {props.resetPasswordMessage}
            </span>
          ) : null}

          <div className="form-response AuthForm__fields">
            <FormField
              className="AuthForm__field"
              type={INPUT_TYPES.email}
              label={props.emailLabel}
              value={props.email}
              validationMode={ValidationMode.onBlur}
              constraints={props.currentMode === AuthModalMode.SIGNUP ? emailConstraints : constraints}
              validateImmediately={props.validateImmediately}
              isEditing={true}
              isSaving={props.isFetching}
              onChange={props.onChangeEmail}
              onValidationChange={props.onValidationChangeEmail}
            />
            {props.currentMode !== AuthModalMode.FORGOT_PASSWORD ? (
              <FormField
                className="AuthForm__field"
                type={INPUT_TYPES.password}
                label={props.passwordLabel}
                value={props.password}
                validationMode={ValidationMode.onBlur}
                constraints={props.currentMode === AuthModalMode.SIGNUP ? passwordConstraints : constraints}
                validateImmediately={props.validateImmediately}
                isEditing={true}
                isSaving={props.isFetching}
                onChange={props.onChangePassword}
                onValidationChange={props.onValidationChangePassword}
              />
            ) : null}
            {props.currentMode === AuthModalMode.SIGNUP ? (
              <FormField
                className="AuthForm__field"
                type={INPUT_TYPES.password}
                label={props.passwordConfirmLabel}
                value={props.passwordConfirm}
                validationMode={ValidationMode.onBlur}
                constraints={passwordConfirmConstraints}
                validateImmediately={props.validateImmediately}
                isEditing={true}
                isSaving={props.isFetching}
                onChange={props.onChangePasswordConfirm}
                onValidate={props.onValidatePasswordConfirm}
                onValidationChange={props.onValidationChangePasswordConfirm}
              />
            ) : null}
            {props.currentMode === AuthModalMode.SIGNUP ? (
              <FormField
                className="AuthForm__field"
                type={INPUT_TYPES.text}
                label={props.firstNameLabel}
                value={props.firstName}
                validationMode={ValidationMode.onBlur}
                constraints={nameConstraints}
                validateImmediately={props.validateImmediately}
                isEditing={true}
                isSaving={props.isFetching}
                onChange={props.onChangeFirstName}
                onValidationChange={props.onValidationChangeFirstName}
              />
            ) : null}
            {props.currentMode === AuthModalMode.SIGNUP ? (
              <FormField
                className="AuthForm__field"
                type={INPUT_TYPES.text}
                label={props.lastNameLabel}
                value={props.lastName}
                validationMode={ValidationMode.onBlur}
                constraints={nameConstraints}
                validateImmediately={props.validateImmediately}
                isEditing={true}
                isSaving={props.isFetching}
                onChange={props.onChangeLastName}
                onValidationChange={props.onValidationChangeLastName}
              />
            ) : null}
            {props.currentMode === AuthModalMode.SIGNUP ? (
              <FormField
                className="AuthForm__field"
                type={INPUT_TYPES.text}
                label={props.displayNameLabel}
                value={props.displayName}
                disabledInput={true}
                isEditing={true}
                isSaving={props.isFetching}
              />
            ) : null}
          </div>

          {props.currentMode === AuthModalMode.LOGIN ? (
            <div
              className="AuthForm__resetPasswordButton"
              onClick={props.onClickShowResetPassword}
            >
              {props.resetPasswordLabel}
            </div>
          ) : null}

          {props.currentMode === AuthModalMode.SIGNUP ? (
            <label
              className="AuthForm__tos"
            >
              <input
                className="AuthForm__tos__input"
                disabled={props.isFetching}
                type="checkbox"
                checked={props.acceptTosAndPrivacy}
                onChange={props.onChangeAcceptTosAndPrivacy}
              />
              <span>
                {'I agree to the '}
                <a
                  href={TOS_URL}
                  target="_new"
                >
                  terms of service
                </a>
                {' and '}
                <a
                  href={PRIVACY_URL}
                  target="_new"
                >
                  privacy policy
                </a>
                {'.'}
              </span>
            </label>
          ) : null}

        </div>
      </form>

      <StatefulButton
        className={classNames('AuthForm__okayButton', {
          AuthForm__okayButton_disabled: props.isSaveDisabled,
        })}
        startClassName="AuthForm__okayButton_start"
        disabled={props.isSaveDisabled}
        usePropState={true}
        mode={props.okayButtonMode}
        startLabel={getOkayButtonLabel(props)}
        onClick={props.onClickOkay}
      />
    </div>
  );
}

function getOkayButtonLabel(props) {
  switch (props.currentMode) {
    case AuthModalMode.LOGIN:
      return props.loginLabel;
    case AuthModalMode.SIGNUP:
      return props.signupLabel;
    case AuthModalMode.FORGOT_PASSWORD:
      return props.sendEmailLabel;
  }
}

BaseAuthFormView.propTypes = {
  allowedModes: allowedModesPropType.isRequired,
  currentMode: allowedModesPropType.isRequired,
  showCloseButton: T.bool,
  isModal: T.bool,

  email: T.string,
  password: T.string,
  passwordConfirm: T.string,
  displayName: T.string,
  firstName: T.string,
  lastName: T.string,
  acceptTosAndPrivacy: T.bool,

  onChangeEmail: T.func,
  onValidationChangeEmail: T.func,
  onChangePassword: T.func,
  onValidationChangePassword: T.func,
  onChangePasswordConfirm: T.func,
  onValidationChangePasswordConfirm: T.func,
  onValidatePasswordConfirm: T.func,
  onChangeFirstName: T.func,
  onValidationChangeFirstName: T.func,
  onChangeLastName: T.func,
  onValidationChangeLastName: T.func,
  onChangeAcceptTosAndPrivacy: T.func,
  onCancel: T.func,
  onClickOkay: T.func,
  onClickShowLogin: T.func,
  onClickShowSignup: T.func,
  onClickShowResetPassword: T.func,
  isSaveDisabled: T.bool,
  isFetching: T.bool,
  okayButtonMode: isButtonState,
  errorCode: T.string,
  showSuccess: T.bool,
  // Testing: Needed for storybook error states
  validateImmediately: T.bool,

  displayNameLabel: T.string,
  firstNameLabel: T.string,
  lastNameLabel: T.string,
  emailLabel: T.string,
  passwordLabel: T.string,
  passwordConfirmLabel: T.string,
  loginLabel: T.string,
  signupLabel: T.string,
  sendEmailLabel: T.string,
  resetPasswordLabel: T.string,
  resetPasswordMessage: T.string,
};

BaseAuthFormView.defaultProps = {
  keyboardHeight: 0,
  isModal: false,
};

export const AuthFormView = I18nComponent(BaseAuthFormView, [
  {code: 'onboarding.join.displayname', prop: 'displayNameLabel'},
  {code: 'onboarding.join.first', prop: 'firstNameLabel'},
  {code: 'onboarding.join.last', prop: 'lastNameLabel'},
  {code: 'onboarding.join.email', prop: 'emailLabel'},
  {code: 'onboarding.join.password', prop: 'passwordLabel'},
  {code: 'onboarding.join.password.confirm', prop: 'passwordConfirmLabel'},
  {code: 'onboarding.join.login.label', prop: 'loginLabel'},
  {code: 'onboarding.join.signup.label', prop: 'signupLabel'},
  {code: 'onboarding.join.sendemail.label', prop: 'sendEmailLabel'},
  {code: 'onboarding.join.resetpassword.label', prop: 'resetPasswordLabel'},
  {code: 'onboarding.join.resetpassword.message', prop: 'resetPasswordMessage'},
]);



// WEBPACK FOOTER //
// ./src/js/auth/components/AuthForm/AuthFormView.js